// TODO: Follow best practices!
// TODO: move to separete folder
export const saveTextAsFile = (content: BlobPart, filename: string): void => {
	if (!content || !filename) {
		// TODO: throw error or send event
		return;
	}

	const blob = new Blob([content], { type: 'text/plain' });
	const a = document.createElement('a');

	a.download = filename;
	a.href = window.URL.createObjectURL(blob);
	a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
	document.body.appendChild(a);
	a.click();
	a.remove();
};
